import React, { useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link, useNavigate } from 'react-router-dom'
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import {
  get_card_products,
  delete_card_product,
  messageClear,

} from '../store/reducers/cardReducer'
import { get_customer } from '../store/reducers/authReducer'
// import { get_currencyIQD } from '../store/reducers/dashboardReducer'
import { useTranslation } from 'react-i18next'
import toast from 'react-hot-toast'
import { backend_url_img } from '../api/server'
import { AiOutlineShopping } from 'react-icons/ai'
// import { socket } from '../utils/utils'

const Card = () => {
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const { userInfo, customerProfile } = useSelector((state) => state.auth)
  const {
    card_products,
    successMessage,
    buy_product_item,
    shipping_fee,
    outofstock_products,
  } = useSelector((state) => state.card)

  const navigate = useNavigate()

  useEffect(() => {
    dispatch(get_card_products(userInfo?.id))
    dispatch(get_customer(userInfo?.id))
    // dispatch(get_currencyIQD())
  }, [])

   

  const calculateTotalPrice = () => {
    return card_products.reduce((total, p) => {
      if (!p || !p.selectedPack) return total

      const itemQuantity = p.quantity || 0
      const productCode = Number(p.selectedPack?.pack?.code) || 0
      const productPrice = p.selectedPack?.price ?? 0

      return total + itemQuantity * productCode * productPrice
    }, 0)
  }



  const calculateDiscountAmount = () => {
    if (!customerProfile?.discount) return 0
    return calculateTotalPrice() * (customerProfile.discount / 100)
  }

  const redirect = () => {
    navigate('/shipping', {
      state: {
        products: card_products,
        price: calculateTotalPrice() - calculateDiscountAmount(),
        shipping_fee: shipping_fee,
        items: buy_product_item,
      },
    })
  }

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage)
      dispatch(messageClear())
      dispatch(get_card_products(userInfo?.id))
    }
  }, [successMessage])

  // const inc = (quantity, stock, card_id) => {
  //   const temp = quantity + 1
  //   if (temp <= stock) {
  //     dispatch(quantity_inc(card_id))
  //   }
  // }

  // const dec = (quantity, card_id) => {
  //   const temp = quantity - 1
  //   if (temp !== 0) {
  //     dispatch(quantity_dec(card_id))
  //   }
  // }

  const getProductName = (product) => {
    switch (currentLanguage) {
      case 'ar':
        return product?.arName
      case 'kr':
        return product?.kuName
      default:
        return product?.enName
    }
  }

  return (
    <div>
      <Header />
      <section className=" mt-5 bg-cover bg-no-repeat relative bg-left">
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[65%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white"></div>
          </div>
        </div>
      </section>
      <section>
        <div className=" bg-slate-100 py-5 mb-2">
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex justify-start items-center text-md text-slate-600 w-full">
              <Link to="/"> {t('home.home')}</Link>
              <span>
                <span>
                  {isRTL ? <IoIosArrowBack /> : <IoIosArrowForward />}
                </span>
              </span>
              <span>{t('home.cart')}</span>

              {/* <span >{category} </span> */}
              {/* <span>
                <IoIosArrowForward />
              </span>
              <span className="text-[#B65278]">{searchValue} </span> */}
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="w-[70%] lg:w-[90%] md:w-[90%] sm:w-[90%] mx-auto py-8 sm:px-0">
          {card_products.length > 0 || outofstock_products > 0 ? (
            <div className="flex flex-wrap ">
              <div className="w-[67%] md-lg:w-full border rounded-md p-2 ">
                <div className="px-2 md-lg:px-0">
                  <div className="flex flex-col gap-3">
                    <div className=" w-full py-3">
                      <h2 className="text-lg text-primary font-semibold">
                        {t('home.cart_products')} {card_products.length}
                      </h2>
                    </div>

                    {card_products?.map((p, i) => (
                      <div
                        className="flex bg-white shadow-md border border-slate-50 p-4 flex-col gap-2"
                        key={p._id}
                      >
                        <div className="flex justify-start items-center gap-4 py-2">
                          <h2 className="text-sm text-slate-600 font-bold">
                            {getProductName(p.productInfo)}
                          </h2>
                          <div className="flex justify-center items-center ">
                            <span className="font-medium">
                              {t('products.product_code')}:{' '}
                              {p.productInfo.productCode}
                            </span>
                          </div>
                        </div>

                        <div className="w-full flex flex-wrap">
                          <div className="flex sm:w-full  items-center gap-2 w-8/12">
                            <div className="flex gap-2 justify-start items-center">
                              <img
                                className="w-[100px] h-auto"
                                src={`${backend_url_img}/${p?.productInfo.images[0]}`}
                                alt={p.productInfo.enName || 'Product Image'}
                              />
                              <div className="px-2  text-white">
                                {p.selectedPack ? (
                                  <div
                                    className="flex flex-col text-sm font-semibold w-full gap-2"
                                    key={
                                      p.selectedPack._id ||
                                      p.selectedPack.pack.code
                                    }
                                  >
                                    {/* Pack Info */}
                                    <div className="flex gap-2 items-center px-2 py-2 bg-darkRed justify-center border rounded-md ">
                                      <span className="font-base">
                                        {p.selectedPack.pack?.code} ×{' '}
                                        {getProductName(p.selectedPack.pack)}
                                      </span>
                                      <span className="text-sm font-normal text-white">
                                        ({p.selectedPack.price?.toFixed(2)}{' '}
                                        {t('products.currency')})
                                      </span>
                                    </div>

                                    {/* Properties */}
                                    <div className="flex flex-col gap-1 px-1">
                                      {p.selectedPack.properties?.length > 0 ? (
                                        p.selectedPack.properties.map(
                                          (prop, propIndex) => (
                                            <div
                                              key={prop._id || propIndex}
                                              className="flex items-center gap-2"
                                            >
                                              <span className="font-light">
                                                {prop}
                                              </span>
                                            </div>
                                          )
                                        )
                                      ) : (
                                        <span className="text-sm font-light text-slate-400">
                                          {t('home.no_properties_available')}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  <span className="text-sm font-light text-slate-400">
                                    {t('home.no_pack_selected')}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="flex item-center justify-center w-4/12 sm:w-full sm:mt-3">
                            <span className=" px-2 font-medium text-lg">
                              {t('products.price')}:
                            </span>
                            <div className="flex w-full sm:w-full justify-between">
                              <div className="">
                                {/* {p.productInfo.discount > 0 ? (
                                  <>
                                    <h3
                                      className={`font-medium text-sm text-orange-500 ${
                                        isRTL ? 'flex-row' : ''
                                      }`}
                                    >
                                      {p.selectedPack
                                        ? new Intl.NumberFormat('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(
                                            (p.selectedPack.price *
                                              p.selectedPack.pack.code *
                                              p.productInfo.discount) /
                                              100
                                          )
                                        : ''}
                                      {new Intl.NumberFormat('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }).format(
                                        p.productInfo.price * currencyIQD -
                                          Math.floor(
                                            (p.productInfo.price *
                                              currencyIQD *
                                              p.productInfo.discount) /
                                              100
                                          )
                                      )}
                                      {' '}
                                      {t('products.currency')}
                                    </h3>
                                    <p className="line-through">
                                      {p.selectedPack
                                        ? new Intl.NumberFormat('en-US', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                          }).format(
                                            p.selectedPack.price *
                                              p.selectedPack.pack.code
                                          )
                                        : ''}{' '}
                                      
                                      {t('products.currency')}
                                    </p>
                                    <p>-{p.productInfo.discount}%</p>
                                  </>
                                ) : (
                                  <> */}
                                <h2
                                  className={`text-lg text-orange-500 ${
                                    isRTL ? 'flex-row' : ''
                                  }`}
                                >
                                  {p.selectedPack
                                    ? new Intl.NumberFormat('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }).format(
                                        p.selectedPack.price *
                                          p.selectedPack.pack.code
                                      )
                                    : ''}{' '}
                                  {t('products.currency')}
                                </h2>
                                {/* </>
                                )} */}
                              </div>

                              <div className="flex flex-col gap-2">
                                <button
                                  onClick={() =>
                                    dispatch(delete_card_product(p._id))
                                  }
                                  className="px-2 py-[3px] rounded-md bg-red-500 text-white"
                                >
                                  {t('home.delete')}
                                </button>
                                {/* <div className="px-2 py-[3px] rounded-md bg-red-500 text-white">
                                  <Link
                                    to={`/product/details/${p.productInfo.slug}`}
                                    state={{ cartItemsSelected: p.cartItems }}
                                  >
                                    {t('home.edit')}
                                  </Link>
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`flex items-center justify-start sm:justify-center text-sm font-bold ${
                            isRTL ? 'rtl text-right' : 'ltr text-left'
                          } px-2 pt-2`}
                        >
                          <h2 className="px-2  whitespace-nowrap">
                            {t('home.total_price')} :
                          </h2>
                          <span className="whitespace-nowrap">
                            {(() => {
                              if (!p?.selectedPack) return null

                              const packCode =
                                Number(p.selectedPack.pack?.code) || 0
                              const quantity = Number(p.quantity) || 0
                              const packPrice =
                                Number(p.selectedPack.price) || 0

                              const totalPrice = (
                                packCode *
                                quantity *
                                packPrice
                              ).toFixed(2)
                              const currency = t('products.currency')

                              return isRTL
                                ? ` ${quantity} × (${packCode} × ${packPrice.toFixed(
                                    2
                                  )})  = ${totalPrice} ${currency}`
                                : `${quantity} × (${packCode} × ${packPrice.toFixed(
                                    2
                                  )}) = ${totalPrice} ${currency}`
                            })()}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="w-[33%] md-lg:w-full">
                <div className="px-3 md-lg:px-0 md-lg:mt-5 ">
                  {card_products.length > 0 && (
                    <div className="bg-white p-3 text-slate-600 flex flex-col gap-3 border rounded-md">
                      <h2 className="text-md font-bold">
                        {t('orderS.order_summary')}{' '}
                      </h2>

                      <div className="flex justify-between items-center mt-4">
                        <h3 className="font-bold text-sm">
                          {t('orderS.total_price')}:
                        </h3>
                        <div className="flex text-lg font-bold">
                          {new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }).format((calculateTotalPrice() / 250) * 250)}{' '}
                          {t('products.currency')}
                        </div>
                      </div>

                      <div className="flex justify-between items-center">
                        <span>{t('orderS.delivery_fee')}</span>
                        <span>
                          {new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }).format((shipping_fee / 250) * 250)}{' '}
                          {t('products.currency')}
                        </span>
                      </div>

                      <div className="flex gap-2">
                        <input
                          className="w-full px-3 py-2 border border-slate-200 outline-0 focus:border-green-500 rounded-sm"
                          type="text"
                          placeholder={t('orderS.input_voucher_coupon')}
                        />
                        <button className="px-5 py-[1px] bg-[#059473] text-white rounded-md uppercase text-sm">
                          {t('orderS.apply')}
                        </button>
                      </div>
                      {customerProfile?.discount &&
                      customerProfile?.discount > 0 ? (
                        <div className="flex justify-between items-center py-4">
                          <span className="text-sm font-bold">
                            {t('home.discount')}
                          </span>
                          <span className="text-lg font-bold">
                            {new Intl.NumberFormat('en-US', {
                              minimumFractionDigits: 0,
                              maximumFractionDigits: 0,
                            }).format(
                              (
                                (calculateTotalPrice() *
                                  (customerProfile?.discount / 100)) /
                                  250
                              ) * 250
                            )}{' '}
                            {t('products.currency')}
                          </span>
                        </div>
                      ) : null}

                      <div className="flex justify-between items-center py-4">
                        <span className="text-sm font-bold">
                          {t('orderS.total_price')}
                        </span>
                        <span className="text-lg font-bold">
                          {new Intl.NumberFormat('en-US', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }).format(
                            (
                              (calculateTotalPrice() -
                                calculateDiscountAmount() +
                                shipping_fee) /
                                250
                            ) * 250
                          )}{' '}
                          {t('products.currency')}
                        </span>
                      </div>

                      <button
                        onClick={redirect}
                        className="px-5 py-[9px] rounded-md hover:bg-[#4e658e] hover:shadow-lg bg-primary text-md text-white uppercase"
                      >
                        {t('orderS.process_to_heckout')} ({buy_product_item})
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex justify-center items-center h-[400px]">
              <div className="flex flex-col items-center py-4">
                <AiOutlineShopping className="text-gray-300 w-28 h-28" />

                <h2 className="text-lg px-6">{t('home.cart_is_empty')}</h2>

                <div className="py-8">
                  <Link
                    className="bg-primary border border-gray-300 text-white px-8 py-2 rounded-full transition-colors duration-300 hover:bg-darkRed hover:text-white"
                    to="/"
                  >
                    {t('home.shop_now')}
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default Card
